import { useState, FC, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import moment from "moment";

//Components
import Component from "./Component";

//Actions
import { getPricingList } from "../../../../actions/shipperAction";

//Interfaces
import { LogisticListInterface } from "../definitions";
import { WrapperInterface } from "./definitions";

const Wrapper: FC<WrapperInterface> = ({
  onBack,
  continueAction,
  toOutOfReach,
  selectedAddress,
  sale_id,
  seller_responded,
  isConsignments,
}) => {
  const [logisticList, setLogisticList] = useState<Array<LogisticListInterface>>([])
  const [expressList, setExpressList] = useState<Array<LogisticListInterface>>([])
  const [regularList, setRegularList] = useState<Array<LogisticListInterface>>([])
  const [gettingRegular, setGettingRegular] = useState(true);
  const [gettingExpress, setGettingExpress] = useState(true);

  const [rateType, setRateType] = useState("")
  const [loading, setLoading] = useState(true)
  
  const getArriveLimitTime = () => {
    const endTime = moment(seller_responded).valueOf();
    const interval = 120 * 3600000;
    return endTime + interval;
  }

  const convertDate = () => {
    const resultTime = getArriveLimitTime()
    return moment(resultTime).format("MMMM Do, YYYY HH.MM")
  }

  const disableRegular = !regularList.length;
  const disableExpress = !expressList.length;
  const setToRegular = () => !disableRegular && setRateType("regular");
  const setToExpress = () => !disableExpress && setRateType("express")

  const checkCourierExpired = (day) => {
    const arriveTime = getArriveLimitTime()

    return moment().add(day, "day").isAfter(arriveTime)
  }

  const onSelectHandler = (data) => {
    continueAction(data)
  }

  const getRegularPricing = async () => {
    try {
        const payload = {
          seller_shipping_id: selectedAddress?.id,
          rate_type: 'regular'
        }
        if (isConsignments) {
          payload['sell_consignment_id'] = sale_id;
        } else {
          payload['sale_id'] = sale_id
        }
      await getPricingList(payload)
        .then(res => res?.data)
        .then(res => setRegularList(res.data))
        .catch(err => { throw err })
        .finally(() => setGettingRegular(false))
    } catch (err) {
      setGettingRegular(false)
      console.log(err, "Error when try to get pricing list")
    }
  }

  const getExpressPricing = async () => {
    try {
      const payload = {
        seller_shipping_id: selectedAddress?.id,
        rate_type: 'express'
      }
      if (isConsignments) {
        payload['sell_consignment_id'] = sale_id;
      } else {
        payload['sale_id'] = sale_id
      }
      await getPricingList(payload)
        .then(res => res?.data)
        .then(res => setExpressList(res.data))
        .catch(err => { throw err })
        .finally(() => setGettingExpress(false))
    } catch (err) {
      setGettingExpress(false)
      console.log(err, "Error when try to get pricing list")
    }
  }

  useEffect(() => {
    if(gettingRegular || gettingExpress) return;
    
    if(!expressList.length && !regularList.length) {
      //Go to out of react
      toOutOfReach()
      setLoading(false)
      return;
    }

    if(regularList.length) {
      setLogisticList(regularList)
      setRateType('regular')
      setLoading(false)
      return;
    }

    if(expressList.length) {
      setLogisticList(expressList)
      setRateType('express')
      setLoading(false)
      return;
    }

  }, [gettingRegular, gettingExpress])

  useEffect(() => {
    if(rateType === "regular") {
      setLogisticList(regularList)
    } else if(rateType === "express") {
      setLogisticList(expressList)
    }
  }, [rateType])

  useEffect(() => {
    getExpressPricing()
    getRegularPricing()
  }, [])

  return (
    <Component
      convertDate={convertDate()}
      loading={loading}
      rateType={rateType}
      logisticList={logisticList}
      disableRegular={disableRegular}
      disableExpress={disableExpress}
      onSelectHandler={onSelectHandler}
      checkCourierExpired={checkCourierExpired}
      onBack={onBack}
      setToRegular={setToRegular}
      setToExpress={setToExpress}
    />
  )
}
export default Wrapper;